/**
 * @generated SignedSource<<7360bb8fccf091e91cbdda4d17e80058>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleResultsFormFieldPie_result",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldContainer_result"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ParticipativeModuleResultsFormFieldChoicesChart_result"
    }
  ],
  "type": "ParticipativeModuleResultsFormFieldPie",
  "abstractKey": null
};

node.hash = "39a11454885ccf70b97b8777bd5b1e60";

module.exports = node;
